/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export enum UserTypes {
  SYSTEM = 'SYSTEM',
  VISITOR = 'VISITOR',
  CLIENT = 'CLIENT',
  USER = 'USER'
}
